/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Typography, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, Divider  } from "@mui/material";
import { taxStatus } from "../../util/DataObject";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const TaxPayment = (props) => {
  const history = useHistory();
  const [zPos, setZPos] = useState(45)
  const [disabled, setDisabled] = useState(true);
  const [form, setForm] = useState({ tax_reference: "" });
  const [error, setErrors] = useState({ tax_reference: "" });
  const [result, setResult] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    init();
    setResult("");
    setDone(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = () => {
    let d = { tax_reference: "" };
    setForm(JSON.parse(JSON.stringify(d)));
    setDisabled(true);
  };

  const changeValue = (field, e) => {
    let f = form;
    let er = error;

    f[field] = e.target.value
    !e.target.value ? er[field] = "Dato obligatorio" : er[field] = ""

    setForm(JSON.parse(JSON.stringify(f)));
    setErrors(JSON.parse(JSON.stringify(er)));
    validateForm(f, er);
  };
  
  const validateForm = (f, err) => {
    if (f["tax_reference"] && !err["tax_reference"]) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };
  
  const send = async () => {
    props.changeLoader(true);
    setZPos(-1)
    let data = form;

    let request = await API.service( "taxPaymentGet", data, props.pos, props.changeAlert, props.changeLoader, history);
    if ( request.status === 200 && request.data.data.response === "OK") {
      setResult(request.data.data.content["status"]);
      setDone(true);
    } else {
      let detail = request.data.message;
      props.changeAlert(true, "error", "Error al realizar la consulta: " + detail);
    }
    props.changeLoader(false);
    setZPos(45)
  };

  const reset = () => {
    init();
    setResult("");
    setDone(false);
  }

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle style={{marginBottom: "0"}} >
          <span>
            Pago de Impuestos Federales
            <p id="subtitle_2">Consultar estatus de pago</p>
          </span>
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent>
          {done ?
            <Grid container spacing={2} sx={{ my: 1 }}>
              <Grid item xs={12}>
                Resultado:
                <Divider sx={{my: 1}}/>
                <Typography fontWeight={700} fontSize={17}>
                  {taxStatus.filter((item) => item.key === result)[0]["label"]}
                </Typography>
              </Grid>
            </Grid>
            :
            <Grid container spacing={2} sx={{ my: 1 }}>
              <Grid item xs={12}>
                <TextField
                  label="Identificador del Pago" value={form.tax_reference} onChange={changeValue.bind(this, "tax_reference")} error={error.tax_reference !== ""} helperText={error.tax_reference ? error.tax_reference : ''} size="small" fullWidth />
              </Grid>
            </Grid>
          }
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          {!done ? 
            <Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Consultar</Button>
            :
            <Button variant="contained" onClick={reset.bind(this)} >Nueva consulta</Button>
          }
          </DialogActions>
      </ModalStyle>
    </Dialog> 
  );
};

export default TaxPayment;
